<template>
	<page>
		<ZuiHeader />
		<div class="listClass pictureList">
			<div class="banner">
				<cms-image :src="linkImg"></cms-image>
				<PageNavigater></PageNavigater>
			</div>
			<div class="contain">
				<div class="content">
					<div class="title-bg"></div>
					<div class="bg">
						<div class="title">精美图库</div>
						<div class="__change m__l"><router-link to="/link/pictures">切换为滚动查看</router-link></div>
						<cms-article-list pid="888" :page="page" :limit="limit" class="data-list" @loaded="listLoaded">
							<template slot-scope="{list}">
								<!-- 当长度大于6的时候，加上experience-more，不然第5、6两个模块样式不一样 -->
								<div class="picture-list-container" :class="isIE ? 'classie' : ''">
									<div class="picture-box" v-for="(item, index) in list" :key="item.id"
										@click="itemClick(item)">
										<div class="bgImg">
											<cms-image :src="item.cover"></cms-image>
											<div class="picture-intro">
												<span class="__title">{{ item.title }}</span>
												<span class="__add">地点：{{ item.ext1 }}</span>
												<span class="__tip">点击查看大图</span>
											</div>
										</div>
									</div>
								</div>
							</template>
						</cms-article-list>
						<!-- 底下分页器做个参数，可有可无 -->
						<div class="page">
							<el-pagination background layout="prev, pager, next" :page-size="10" :total="total"
								@current-change="pageChange">
							</el-pagination>
						</div>
					</div>
				</div>
			</div>
		</div>
		<ZuiFooter />
	</page>
</template>

<script>
	import '~/views/less/list.css'
	export default {
		data() {
			return {
				// list: [],
				total: 0,
				linkImg: require('~/views/img/list/link-banner.jpg'),
				page: 1,
				limit:9,
				isIE: false
			}
		},
		mounted() {
			if(document.getElementsByClassName('zui-page')[0].getAttribute("class").includes("mobileClass")){
				// this.limit = 8
			}
			if (document.documentMode)
				this.isIE = true;
		},
		methods: {
			listLoaded(list, total) {
				this.total = total;
			},
			pageChange(page) {
				this.page = page;
			},
			itemClick(item) {
				this.$viewerApi({
					images: [item.cover],
					options: {
						inline: false,
						button: true,
						navbar: false,
						title: false,
						toolbar: false,
						tooltip: true,
						movable: true,
						zoomable: true,
						rotatable: true,
						scalable: true,
						transition: true,
						fullscreen: true,
						keyboard: true,
					}
				})
				// this.$router.push('/link/pictures/info?id=' + item.id);
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/link/pictureList.vue